var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-detail-purchase-mobile border-caredokter-mobile"},[_c('label',[_vm._v(_vm._s(_vm.staticText.pesanan))]),_vm._l((_vm.list),function(item,index){return [_c('order',{key:index,attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }